import { ShippingDocumentKind } from "generated-graphql/graphql";

import { NO_VALUE_PLACEHOLDER } from "../Containers/containerDisplay";

export { NO_VALUE_PLACEHOLDER };

/** What the list's Ship Date cell reads when the document carries no ship date. */
export const MISSING_SHIP_DATE_LABEL = "No ship date";

/**
 * Shown on the review form. A ship date is not required to save, so this names
 * the consequence instead of blocking: the Year picker on Shipment Documents
 * does not match a manifest with no ship date.
 */
export const MISSING_SHIP_DATE_WARNING =
  "No ship date. This document saves, but the Year picker on Shipment Documents will not match it.";

export const SHIPPING_DOCUMENT_KIND_LABELS: Record<ShippingDocumentKind, string> = {
  [ShippingDocumentKind.BillOfLading]: "Bill of Lading",
  [ShippingDocumentKind.Manifest]: "Manifest",
  [ShippingDocumentKind.Other]: "Other",
};
